// ตำแหน่งทุกอย่างบนกระดาษคำตอบ หน่วยเป็นมิลลิเมตรบน A4 (210 x 297)
//
// ไฟล์นี้เป็นสัญญาระหว่าง "ตัวพิมพ์" กับ "ตัวอ่าน" (ขั้นสแกน) — ทั้งสองต้องเรียกฟังก์ชันเดียวกันนี้
// ห้ามเขียนตัวเลขตำแหน่งซ้ำที่อื่น และห้ามแก้ตัวเลขของแบบที่เคยพิมพ์ไปแล้ว (อาจยังมีแผ่นรอสแกน)
// ถ้าต้องเปลี่ยนแบบกระดาษ ให้เพิ่มแบบใหม่ใน GEOMETRY แล้วขึ้น LAYOUT_VERSION — ของเดิมเก็บไว้ทั้งหมด
//
// ตัวอ่านไม่ต้องรู้ล่วงหน้าว่าแผ่นเป็นแบบไหน: ลองจัดภาพด้วยสี่เหลี่ยมมุมของทุกแบบ (LAYOUT_VERSIONS)
// แบบที่ถอดแถบรหัสผ่าน CRC คือแบบที่ถูก (ดู reader.readSheet) — ตัวเลข "แบบ N" ที่พิมพ์ใต้แถบ
// มีไว้ให้คนอ่านเท่านั้น
//
// ตัวอ่านจัดภาพให้ตรงจากศูนย์กลางสี่เหลี่ยมทึบสี่มุม (markers) แล้วอ่านทุกช่องด้วยพิกัดจากที่นี่
// ตำแหน่งข้อจึงขึ้นกับ "ลำดับของข้อปรนัย" เท่านั้น (ข้ออัตนัยไม่มีช่องฝน) — โครงข้อสอบถูกล็อก
// ทันทีที่มีคำตอบด้วยเหตุผลนี้ (ดู examModel.updateExam)
import { CODE_BITS } from './sheetCode'

export const PAGE = { width: 210, height: 297 }

// ── แบบกระดาษ ────────────────────────────────────────────────────────────────
// แบบ 1–3 (แถบรหัสกลางแผ่น / เผื่อที่เย็บ) ใช้ 25–27 ก.ย. 2569 แล้วลบออกจากตัวอ่าน 28 ก.ย. ตามที่ผู้ใช้สั่ง
// (ให้กล้องลองแบบน้อยลง ลดโอกาสถอดแถบรหัสผิดผังโดยบังเอิญ) — แผ่นที่ยังค้างจากช่วงนั้นสแกนไม่ได้ ครูกรอกเอง
// เลขแบบห้ามนำกลับมาใช้ซ้ำ แบบใหม่ต่อจากเลขล่าสุด
//
// แบบ 4: เต็มหน้า วงปกติ สี่เหลี่ยมมุมห่างขอบกระดาษ 10 มม. ทุกด้าน
// แบบ 5: ครึ่งแผ่นบน วงปกติ — ครึ่งล่างและด้านหลังให้นักเรียนตอบข้ออัตนัย
//        สี่เหลี่ยมมุมล่างอยู่กลางแผ่น (markerBottom) ช่องฝน 10 แถว ห่างแถวละ 6.2 มม.
//        ตัวเลือกไม่เกิน 4 (ก–ง) ได้ 5 คอลัมน์ = 50 ข้อ, 5 ตัวเลือกได้ 4 คอลัมน์ = 40 ข้อ (narrow)
//        กระดาษสำรอง: คอลัมน์สุดท้ายเป็นช่องฝนเลขประจำตัว ใช้ 10 แถวเดียวกับช่องคำตอบ (เลข 0–9 = แถว 1–10)
//        ช่องเขียนเลขทีละหลัก (ซ้ายไปขวา) อยู่เหนือแถวเลข 0 พอดี ป้าย "เลขประจำตัว" อยู่เหนือช่องเขียน — ตัวอ่านไม่ได้อ่าน
// แถบรหัสอยู่ขอบกระดาษทุกแบบ — แถวแรก 26 ช่องอยู่ระหว่างสี่เหลี่ยมมุมบนสองอัน แถวที่สองอยู่ระหว่างสี่เหลี่ยมมุมล่าง
//        และพิมพ์เฉพาะช่องทึบ ไม่มีกรอบของช่องว่าง เพราะแถบกลางแผ่นที่มีช่องสี่เหลี่ยมว่างให้เห็น (แบบ 1–3)
//        นักเรียนฝนเล่นจนรหัสพัง (CRC ไม่ผ่าน ครูต้องเลือกคนเอง)
//        ความขาวอ้างอิงของแต่ละช่องวัดที่เส้นกระดาษด้านนอก (ฝั่งขอบกระดาษ) ซึ่งเป็นขอบว่างเสมอ
//        บรรทัดเลขรหัสแผ่น + คำเตือนอยู่ใต้แถวบนทันที (ฝั่งใน — ฝั่งนอกคือเส้นวัดความขาว ห้ามมีอะไร)
//        คำเตือนของแถวล่าง (frame.labelBottom) ชิดขวาตรงปลายแถบ: เต็มหน้าอยู่เหนือแถว (ซ้ายเป็นบรรทัด "ข้อ .. เป็นอัตนัย")
//        ครึ่งแผ่นเหนือแถวไม่มีที่ (ช่องฝนแถวสุดท้ายชิดอยู่) จึงอยู่ใต้แถว เลยเส้นวัดความขาวไป แล้วเลื่อนพื้นที่ตอบอัตนัยลง
//        ข้อความเตือนเลี่ยงสระล่าง (ุ ู) — ตัวอักษรที่ห้อยลงจะไปแตะแถบหรือเส้นวัดความขาว
//        หัวกระดาษเลื่อนลง (frame.head) ให้พ้นบรรทัดนั้น ส่วนข้อความ "ข้อ .. เป็นอัตนัย" ขึ้นไปอยู่เหนือแถวล่าง (frame.note)
// แบบ 6: วงใหญ่ (เส้นผ่านศูนย์กลาง 6 มม. แทน 4.8) เต็มหน้าอย่างเดียว ครูเลือกเองที่หน้าพิมพ์ เน้นความแม่น
//        (กล้องถือไกล / ถ่ายเอกสารซีด / เด็กฝนเลยวง) แลกกับจำนวนข้อ: 22 แถว x 4 คอลัมน์ (≤ 4 ตัวเลือก) หรือ 3 คอลัมน์
//        สี่เหลี่ยมมุมและแถบรหัสตำแหน่งเดียวกับแบบ 4 ทุกอย่าง — ตัวอ่านจึงแยกสองแบบนี้จากรูปทรงไม่ได้
//        (แถบรหัสถอด CRC ผ่านทั้งสองผัง แล้วอ่านช่องฝนผิดตำแหน่งทั้งแผ่นเงียบๆ) แบบนี้จึง XOR CRC ด้วย codeSalt:
//        อ่านแผ่นแบบ 6 ด้วยผังแบบ 4 (หรือกลับกัน) CRC ไม่ผ่านทุกครั้ง ไม่ใช่แค่ส่วนใหญ่
// แบบ 7: วงใหญ่ 3/5 แผ่นบน — ครึ่งแผ่นใส่วงใหญ่ได้แค่ 9 แถว ช่องฝนเลขประจำตัว 10 แถวต้องย่อวง ผู้ใช้เลือก
//        ให้แผ่นสูงขึ้นแทน: สี่เหลี่ยมมุมล่างที่ y 163.5 (ราว 57% ของความสูง ยังอยู่ในแถบกลางภาพที่ findMarkerSets หา)
//        13 แถว ห่าง 7.4 มม. (ช่องว่างระหว่างวงเท่าแบบ 5) = 52 ข้อ (≤ 4 ตัวเลือก) / 39 ข้อ
//        ช่องฝนเลขประจำตัววงใหญ่เท่าช่องคำตอบ เลข 0–9 ตรงแถวคำตอบ 1–10 เหมือนแบบ 5
//        แถบรหัสแถวบนและกรอบข้อมูลเหมือนแบบ 5 แถวล่างตามสี่เหลี่ยมมุมล่าง (salt ของตัวเองด้วยเหตุผลเดียวกับแบบ 6)
// box = ขอบบนของกรอบข้อมูลนักเรียน / gridY0 = ศูนย์กลางแถวแรกของช่องฝน
// frame.head = ขอบบนของตราโรงเรียน / frame.label = บรรทัดเลขรหัสแผ่นที่คนอ่าน / frame.note = บรรทัด "ข้อ .. เป็นอัตนัย"
// ค่าที่ไม่ระบุ (columns / rows / rowPitch / markerBottom) ใช้ค่าของแบบเต็มหน้า
const GEOMETRY = {
  4: { markerLeft: 10, markerTop: 10, gridX0: 16, gridY0: 78, columnWidth: 44.5, bubbleX0: 12.5, bubblePitch: 6.5,
    codeCenterX: PAGE.width / 2, frame: { left: 18, right: 192, box: 42, head: 21, label: 19.3, labelBottom: 280.3, note: 277.5 } },
  5: { markerLeft: 10, markerTop: 10, markerBottom: 133, gridX0: 16, gridY0: 74, columnWidth: 44.5, bubbleX0: 12.5, bubblePitch: 6.5,
    rows: 10, rowPitch: 6.2, narrow: { maxChoices: 4, columns: 5, columnWidth: 35 },
    id: { dx0: 6, pitch: 6.2, boxY: 64.3, box: 5 },
    codeCenterX: PAGE.width / 2, frame: { left: 18, right: 192, box: 40, head: 21, label: 19.3, labelBottom: 143.8 }, half: true, writtenTop: 146 },
  6: { markerLeft: 10, markerTop: 10, gridX0: 16, gridY0: 80, columns: 3, columnWidth: 58, bubbleX0: 13.5, bubblePitch: 7.6,
    rows: 22, rowPitch: 8.8, bubbleR: 3, narrow: { maxChoices: 4, columns: 4, columnWidth: 44 },
    idFull: { x0: 9, pitch: 7.2, rowPitch: 7.6 }, codeSalt: 0xa5, large: true,
    codeCenterX: PAGE.width / 2, frame: { left: 18, right: 192, box: 42, head: 21, label: 19.3, labelBottom: 280.3, note: 277.5 } },
  7: { markerLeft: 10, markerTop: 10, markerBottom: 163.5, gridX0: 16, gridY0: 70, columns: 3, columnWidth: 58, bubbleX0: 13.5, bubblePitch: 7.6,
    rows: 13, rowPitch: 7.4, bubbleR: 3, narrow: { maxChoices: 4, columns: 4, columnWidth: 44 },
    id: { lastX: 182.8, pitch: 7.2, boxY: 60.5, box: 5 }, codeSalt: 0x3c, large: true,
    codeCenterX: PAGE.width / 2, frame: { left: 18, right: 192, box: 40, head: 21, label: 19.3, labelBottom: 174.3 }, half: true, writtenTop: 176.5 },
}

export const LAYOUT_VERSION = 4                    // แบบเต็มหน้าที่พิมพ์ตอนนี้ (และกระดาษสำรองทุกแผ่น)
export const HALF_VERSION = 5                      // แบบครึ่งแผ่นที่พิมพ์ตอนนี้
export const LARGE_VERSION = 6                     // แบบวงใหญ่เต็มหน้า (ครูเลือกเองที่หน้าพิมพ์)
export const LARGE_HALF_VERSION = 7                // แบบวงใหญ่ 3/5 แผ่น
export const LAYOUT_VERSIONS = [4, 5, 6, 7]       // แบบที่ตัวอ่านรู้จัก (ลองตามลำดับนี้)

// ค่าที่ XOR กับ CRC ของแถบรหัส — แยกแบบที่ใช้สี่เหลี่ยมมุมและแถบรหัสชุดเดียวกัน (ดูแบบ 6) แบบอื่นเป็น 0
export const codeSaltFor = (version) => geo(version).codeSalt || 0

const geo = (version) => {
  const g = GEOMETRY[version]
  if (!g) throw new Error(`ไม่รู้จักกระดาษคำตอบแบบ ${version}`)
  return g
}

// ตำแหน่งของเนื้อหาที่ไม่ได้ถูกอ่าน (หัวกระดาษ กรอบข้อมูลนักเรียน คำชี้แจง) — ตัวพิมพ์ใช้จัดตำแหน่ง
// { left, right, box: ขอบบนของกรอบข้อมูล, head: ขอบบนของหัวกระดาษ, label: บรรทัดเลขรหัสแผ่น,
//   note: บรรทัดท้ายแผ่น, grid: แถวแรกของช่องฝน,
//   half: แบบครึ่งแผ่น, written: ขอบบนของพื้นที่ตอบอัตนัย (เฉพาะแบบครึ่งแผ่น), bubbleR: รัศมีช่องฝน }
export const frameFor = (version = LAYOUT_VERSION) => {
  const g = geo(version)
  return {
    note: PAGE.height - 12,
    ...g.frame,
    grid: g.gridY0,
    half: !!g.half,
    written: g.writtenTop ?? null,
    bubbleR: g.bubbleR ?? BUBBLE_R,
  }
}

const MARKER = 7
export const markersFor = (version = LAYOUT_VERSION) => {
  const { markerLeft: left, markerTop: top, markerBottom } = geo(version)
  const right = PAGE.width - 10 - MARKER
  const bottom = markerBottom ?? PAGE.height - 10 - MARKER
  return [
    { corner: 'tl', x: left, y: top, size: MARKER },
    { corner: 'tr', x: right, y: top, size: MARKER },
    { corner: 'bl', x: left, y: bottom, size: MARKER },
    { corner: 'br', x: right, y: bottom, size: MARKER },
  ]
}
export const MARKERS = markersFor(LAYOUT_VERSION)

// แถบรหัสแผ่น 2 แถว แถวละ 26 ช่อง (ทุกแบบใช้ช่องขนาดเดียวกัน ต่างแค่ตำแหน่ง)
const CODE_PER_ROW = CODE_BITS / 2
const CODE_CELL = 4
const CODE_PITCH = 5.5

// ตารางช่องฝนของแบบเต็มหน้า 4 คอลัมน์ x 25 ข้อ (แบบครึ่งแผ่นดู grid() / capacityOf)
export const COLUMNS = 4
export const ROWS_PER_COLUMN = 25
export const MAX_BUBBLE_QUESTIONS = COLUMNS * ROWS_PER_COLUMN
const ROW_PITCH = 8
const BUBBLE_R = 2.4

// คอลัมน์/แถวของตารางช่องฝนตามแบบและจำนวนตัวเลือก — แบบครึ่งแผ่นใส่ได้ 5 คอลัมน์เมื่อตัวเลือกไม่เกิน 4
const grid = (g, choices) => {
  const narrow = g.narrow && Number(choices) <= g.narrow.maxChoices ? g.narrow : null
  return {
    columns: narrow?.columns ?? g.columns ?? COLUMNS,
    columnWidth: narrow?.columnWidth ?? g.columnWidth,
    rows: g.rows ?? ROWS_PER_COLUMN,
    rowPitch: g.rowPitch ?? ROW_PITCH,
  }
}

// จำนวนข้อปรนัยสูงสุดที่แบบนั้นรับได้ (กระดาษสำรองเสียหนึ่งคอลัมน์ให้ช่องฝนเลขประจำตัว)
export const capacityOf = (version, choices, spare = false) => {
  const { columns, rows } = grid(geo(version), choices)
  return (spare ? columns - 1 : columns) * rows
}

// แบบที่จะพิมพ์: ข้อปรนัยพอครึ่งแผ่นก็พิมพ์ครึ่งแผ่น ไม่พอพิมพ์เต็มหน้า — กระดาษสำรองคิดแยก (รับได้น้อยกว่าหนึ่งคอลัมน์)
// ข้อสอบชุดเดียวกันจึงได้แผ่นปกติครึ่งแผ่นแต่แผ่นสำรองเต็มหน้าได้ ตัวอ่านแยกแบบจากแถบรหัสอยู่แล้ว
export const objectiveCount = (questions) => questions.filter((q) => q.eq_type === 'choice' || q.eq_type === 'truefalse').length
// large = ครูเลือกวงใหญ่ (เกินความจุแล้ว bubbleLayout ปฏิเสธ ไม่ถอยไปวงปกติเอง)
// full = ครูเลือกเต็มหน้าแม้ข้อพอครึ่งแผ่น — ไม่เลือก = ครึ่งแผ่นเมื่อข้อพอ (ค่าตั้งต้นเดิม)
export const sheetVersionFor = (questions, choices, spare = false, large = false, full = false) => {
  const [fullV, halfV] = large ? [LARGE_VERSION, LARGE_HALF_VERSION] : [LAYOUT_VERSION, HALF_VERSION]
  return !full && objectiveCount(questions) <= capacityOf(halfV, choices, spare) ? halfV : fullV
}

// ---- กระดาษสำรอง: ช่องฝนเลขประจำตัวอยู่ในคอลัมน์ที่ 4 ของตารางคำตอบ ----
// ข้อ 1-75 อยู่ตำแหน่งเดิมทุกข้อ ตัวอ่านใช้ bubbleLayout ตัวเดียวกันได้ กระดาษสำรองจึงรับข้อปรนัย
// ได้ 3 คอลัมน์ ส่วนคอลัมน์ที่ 4 เป็นช่องเขียน + ช่องฝนเลข 5 หลัก (เลขประจำตัวนักเรียนเกือบทั้งหมด
// เป็นตัวเลข 5 หลัก — คนที่ไม่ใช่ ครูเลือกนักเรียนเองตอนสแกน)
export const ID_DIGITS = 5
export const SPARE_MAX_OBJECTIVE = (COLUMNS - 1) * ROWS_PER_COLUMN
// ระยะนับจากแถวแรกของตาราง (gridY0 ของแบบนั้น)
const ID_TITLE_DY = 0                       // บรรทัดหัว "เลขประจำตัว"
const ID_BOX_DY = 3                         // ช่องเขียนเลขด้วยมือ (ให้ครูเทียบกับที่ฝน)
const ID_BOX = 5.4
const ID_DY0 = 14                           // ศูนย์กลางแถวเลข 0
const ID_PITCH = 7

// เลข 0–9 สีดำท้ายแถว (ตัวอ่านไม่ได้อ่าน — เลขเทาในวงจางหายเมื่อถ่ายเอกสาร) วางขวาของหลักสุดท้าย
// พ้นวงแหวนที่ตัวอ่านวัดความขาว (r + 0.8) ทางซ้ายเคยลอง — ครึ่งแผ่น 4 ตัวเลือกเบียดคอลัมน์ข้อ 31–40
// ครึ่งแผ่น 4 ตัวเลือก: เลข 9 ห่างสี่เหลี่ยมมุมขวาล่างราว 2 มม. — ภาพสังเคราะห์วาดเลขนี้ด้วย (ต้องไม่ถูกนับรวมกับมุม)
const ID_ROW_LABEL_GAP = 1.0   // + รัศมีวงของแบบนั้น

// คืน { titleX, titleY, titleAnchor, rowLabelX, boxes: [{x, y, size}], digits: [{ index, bubbles: [{ value, label, cx, cy, r }] }] }
// choices มีผลเฉพาะแบบครึ่งแผ่น (จำนวนคอลัมน์ขึ้นกับจำนวนตัวเลือก)
export const idLayout = (version = LAYOUT_VERSION, choices = 5) => {
  const g = geo(version)
  const { columns, columnWidth, rowPitch } = grid(g, choices)
  const colX = g.gridX0 + (columns - 1) * columnWidth
  const r = g.bubbleR ?? BUBBLE_R
  if (g.id) {
    // แบบส่วนบน (5 / 7): เลข 0–9 วางตรงแถวคำตอบ 1–10 ช่องเขียนเลขอยู่เหนือแถวเลข 0
    // ป้ายอยู่เหนือช่องเขียน (ทางซ้ายชนบรรทัดคำชี้แจงที่อยู่แถวเดียวกัน)
    // id.r / id.rowPitch ไม่ระบุ = เท่าช่องคำตอบ (ทุกแบบตอนนี้) — 10 แถวต้องจบก่อนสี่เหลี่ยมมุมล่าง
    const idR = g.id.r ?? r
    const digits = Array.from({ length: ID_DIGITS }, (_, d) => {
      // id.lastX = ชิดขวาตำแหน่งเดียวทุกจำนวนตัวเลือก (แบบ 7) — 5 ตัวเลือกคอลัมน์สุดท้ายเริ่มซ้ายกว่า
      // ป้าย "เลขประจำตัว" จะไปชนบรรทัดคำชี้แจงที่อยู่แถวเดียวกัน (ยาวขึ้นเมื่อมีข้อใช่/ไม่ใช่)
      const cx = g.id.lastX != null
        ? g.id.lastX - (ID_DIGITS - 1 - d) * g.id.pitch
        : colX + g.id.dx0 + d * g.id.pitch
      return {
        index: d,
        cx,
        bubbles: Array.from({ length: 10 }, (_, v) => ({
          value: String(v), label: String(v), cx, cy: g.gridY0 + v * (g.id.rowPitch ?? rowPitch), r: idR,
        })),
      }
    })
    const { boxY, box } = g.id
    return {
      titleX: (digits[0].cx + digits[ID_DIGITS - 1].cx) / 2,
      titleY: boxY - 1.3,
      titleAnchor: 'middle',
      rowLabelX: digits[ID_DIGITS - 1].cx + idR + ID_ROW_LABEL_GAP,
      boxes: digits.map((d) => ({ x: d.cx - box / 2, y: boxY, size: box })),
      digits,
    }
  }
  const digits = Array.from({ length: ID_DIGITS }, (_, d) => {
    // แบบวงใหญ่ใช้ระยะของตัวเอง (idFull) — ระยะของช่องคำตอบกว้างจนหลักที่ 5 ล้นขอบขวา
    const cx = colX + (g.idFull?.x0 ?? g.bubbleX0) + d * (g.idFull?.pitch ?? g.bubblePitch)
    return {
      index: d,
      cx,
      bubbles: Array.from({ length: 10 }, (_, v) => ({
        value: String(v), label: String(v), cx, cy: g.gridY0 + ID_DY0 + v * (g.idFull?.rowPitch ?? ID_PITCH), r,
      })),
    }
  })
  return {
    titleX: colX + 5,
    titleY: g.gridY0 + ID_TITLE_DY,
    titleAnchor: 'start',
    rowLabelX: digits[ID_DIGITS - 1].cx + r + ID_ROW_LABEL_GAP,
    boxes: digits.map((d) => ({ x: d.cx - ID_BOX / 2, y: g.gridY0 + ID_BOX_DY, size: ID_BOX })),
    digits,
  }
}

const CHOICE_LABELS = ['ก', 'ข', 'ค', 'ง', 'จ']
const TF_OPTIONS = [{ value: 'T', label: 'ถ' }, { value: 'F', label: 'ผ' }]

// คืน [{ index, x, y, size, wy }] — wy = เส้นกระดาษว่างที่ตัวอ่านใช้วัดความขาวของช่องนั้น (ตรงคอลัมน์เดียวกัน)
//   แถวบนอยู่แนวเดียวกับสี่เหลี่ยมมุมบน แถวล่างแนวเดียวกับมุมล่าง วัดขาวด้านนอก (ขอบกระดาษ ว่างเสมอ)
const CODE_WHITE_GAP = 1.25
export const codeCells = (version = LAYOUT_VERSION) => {
  const g = geo(version)
  const x0 = g.codeCenterX - ((CODE_PER_ROW - 1) * CODE_PITCH + CODE_CELL) / 2
  const rowY = markersFor(version)
    .filter((m) => m.corner.endsWith('l'))
    .sort((a, b) => a.y - b.y)
    .map((m) => m.y + (m.size - CODE_CELL) / 2)
  return Array.from({ length: CODE_BITS }, (_, i) => {
    const row = Math.floor(i / CODE_PER_ROW)
    const y = rowY[row]
    return {
      index: i,
      x: x0 + (i % CODE_PER_ROW) * CODE_PITCH,
      y,
      size: CODE_CELL,
      wy: row === 0 ? y - CODE_WHITE_GAP : y + CODE_CELL + CODE_WHITE_GAP,
    }
  })
}

// questions = [{ eq_no, eq_type }] เรียงตาม eq_no — คืนตำแหน่งเลขข้อและช่องฝนของข้อปรนัย
// spare = กระดาษสำรอง (คอลัมน์ที่ 4 เป็นช่องฝนเลขประจำตัว) — ตำแหน่งข้อเหมือนกระดาษปกติทุกข้อ ต่างแค่เพดาน
export const bubbleLayout = (questions, choices, spare = false, version = LAYOUT_VERSION) => {
  const g = geo(version)
  const objective = questions.filter((q) => q.eq_type === 'choice' || q.eq_type === 'truefalse')
  const { columnWidth, rows, rowPitch } = grid(g, choices)
  const max = capacityOf(version, choices)
  if (objective.length > max) {
    throw new Error(`กระดาษ${g.half ? 'ครึ่งแผ่น' : g.large ? 'วงใหญ่' : 'หนึ่งแผ่น'}รับข้อปรนัยได้ไม่เกิน ${max} ข้อ`)
  }
  if (spare && objective.length > capacityOf(version, choices, true)) {
    throw new Error(`กระดาษสำรองรับข้อปรนัยได้ไม่เกิน ${capacityOf(version, choices, true)} ข้อ (คอลัมน์สุดท้ายเป็นช่องฝนเลขประจำตัว)`)
  }
  return objective.map((q, i) => {
    const colX = g.gridX0 + Math.floor(i / rows) * columnWidth
    const cy = g.gridY0 + (i % rows) * rowPitch
    const options = q.eq_type === 'truefalse'
      ? TF_OPTIONS
      : CHOICE_LABELS.slice(0, choices).map((label, k) => ({ value: String(k + 1), label }))
    return {
      eq_no: q.eq_no,
      eq_type: q.eq_type,
      numberX: colX + 8,
      cy,
      bubbles: options.map((o, k) => ({
        value: o.value,
        label: o.label,
        cx: colX + g.bubbleX0 + k * g.bubblePitch,
        cy,
        r: g.bubbleR ?? BUBBLE_R,
      })),
    }
  })
}
